var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.625 11c-.34458 0-.625-.2804-.625-.625v-7.08333c0-.34459.28042-.625.625-.625h.625v-1.04167c0-.34458.28042-.625.625-.625h7.5c.3446 0 .625.28042.625.625v7.5c0 .34458-.2804.625-.625.625h-1.04167v.625c0 .3446-.28041.625-.625.625zm0-7.91667c-.115 0-.20833.09334-.20833.20834v7.08333c0 .115.09333.2083.20833.2083h7.08333c.115 0 .20834-.0933.20834-.2083v-.625h-6.04167c-.34458 0-.625-.28042-.625-.625v-6.04167zm1.25-1.66666c-.115 0-.20833.09333-.20833.20833v7.5c0 .115.09333.20833.20833.20833h7.5c.115 0 .2083-.09333.2083-.20833v-7.5c0-.115-.0933-.20833-.2083-.20833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.12333 3.08208c-.115 0-.20833-.09333-.20833-.20833s.09333-.20833.20833-.20833h5c.115 0 .20834.09333.20834.20833s-.09334.20833-.20834.20833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.12333 4.74875c-.115 0-.20833-.09333-.20833-.20833s.09333-.20834.20833-.20834h5c.115 0 .20834.09334.20834.20834s-.09334.20833-.20834.20833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.12333 6.41542c-.115 0-.20833-.09334-.20833-.20834s.09333-.20833.20833-.20833h5c.115 0 .20834.09333.20834.20833s-.09334.20834-.20834.20834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.12333 8.08208c-.115 0-.20833-.09333-.20833-.20833s.09333-.20833.20833-.20833h2.29334c.115 0 .20833.09333.20833.20833s-.09333.20833-.20833.20833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.84914eccbdac4687f501e882c8f25ba3.svg";
export { ForwardRef as ReactComponent };